var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('template-administrator',[_c('div',{attrs:{"slot":"container"},slot:"container"},[_c('button-create-dispatch'),_c('br'),_c('table-dispatch')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }